const ALWAYS = 'ALWAYS'
const OPTIONAL = 'OPTIONAL'
const NONE = 'NONE'

export const SPACES = {
  ALWAYS,
  OPTIONAL,
  NONE
}

const always = () => {
  return {
    before: SPACES.ALWAYS,
    after: SPACES.ALWAYS
  }
}

const optional = () => {
  return {
    before: SPACES.OPTIONAL,
    after: SPACES.OPTIONAL
  }
}

const none = () => {
  return {
    before: SPACES.NONE,
    after: SPACES.NONE
  }
}

const reference = () => {
  return {
    before: SPACES.OPTIONAL,
    after: SPACES.ALWAYS
  }
}

const operator = () => {
  return {
    before: SPACES.OPTIONAL,
    after: SPACES.ALWAYS
  }
}

const TOKEN_DEFAULT_SPACES = optional

const TOKEN_SPACES = {
  EOF: none,
  TOKEN: optional,
  ISODATE: reference,
  // references
  BREF: reference,
  TREF: reference,
  NREF: reference,
  ARRAYREF: reference,
  TRAIT: reference,
  CODEBOOK: optional,
  TAG: optional,
  // values:
  NUMBER: optional,
  STR: (parserResult, token) => {
    const nonParsed = parserResult.text.nonParsed.trim()
    const parsed = parserResult.text.parsed.trim()
    const tokenIsQuote = '"' === token || "'" === token

    return {
      before: !parsed || (nonParsed && tokenIsQuote) ? SPACES.NONE : SPACES.ALWAYS,
      after: SPACES.OPTIONAL
    }
  },
  // operators
  LIKE: operator,
  AND: operator,
  OR: operator,
  IN: operator,
  NOT: operator,
  NOT_IN: operator,
  CODEBOOK_IN: operator,
  CODEBOOK_EQ: operator,
  CODEBOOK_NEQ: operator,
  TAG_IN: operator,
  TAG_EQ: operator,
  TAG_NEQ: operator,
  IN_SHAPE: operator,
  IN_SECTION: operator,
  // operators: compare
  EQ: always,
  NEQ: always,
  LE: always,
  GE: always,
  LT: always,
  GT: always,
  // operators
  MAX: operator,
  MAXPOS: operator,
  MAXPOSITION: operator,
  MIN: operator,
  MINPOS: operator,
  MINPOSITION: operator,
  COUNT: operator,
  // operators: math
  MLT: operator,
  DIV: operator,
  ADD: operator,
  SUB: operator,
  // other
  COMMA: () => {
    return {
      before: SPACES.NONE,
      after: SPACES.ALWAYS
    }
  },
  LPAREN: () => {
    return {
      before: SPACES.OPTIONAL,
      after: SPACES.NONE
    }
  },
  RPAREN: () => {
    return {
      before: SPACES.NONE,
      after: SPACES.OPTIONAL
    }
  }
}

const detectTokenSpaces = (parserResult, token, label) =>
  (TOKEN_SPACES[token] || TOKEN_DEFAULT_SPACES)(parserResult, label)

const calculateSpaceBefore = ({ newTextBefore, prevTokenSpaceAfter, nextTokenSpaceBefore }) => {
  if (nextTokenSpaceBefore === SPACES.NONE) {
    return ''
  }
  if (prevTokenSpaceAfter === SPACES.ALWAYS || nextTokenSpaceBefore === SPACES.ALWAYS) {
    return ' '
  }
  if (prevTokenSpaceAfter === SPACES.NONE) {
    return ''
  }
  if (newTextBefore.trim()) {
    return ' '
  }
  return ''
}

const calculateSpaceAfter = ({ newTextAfter, nextTokenSpaceAfter }) => {
  if (nextTokenSpaceAfter === SPACES.ALWAYS) {
    return ' '
  }

  if (nextTokenSpaceAfter === SPACES.NONE) {
    return ''
  }

  if (newTextAfter.trim()) {
    return ' '
  }

  return ''
}

export default function insertSpaces({ newTextBefore, newTextAfter, token, label, previousToken, parserResult }) {
  const previousTokenSpaces = detectTokenSpaces(parserResult, previousToken, label)
  const currentTokenSpaces = detectTokenSpaces(parserResult, token, label)

  return {
    spaceBefore: calculateSpaceBefore({
      newTextBefore,
      prevTokenSpaceAfter: previousTokenSpaces.after,
      nextTokenSpaceBefore: currentTokenSpaces.before
    }),
    spaceAfter: calculateSpaceAfter({
      newTextAfter,
      nextTokenSpaceAfter: currentTokenSpaces.after
    })
  }
}
